import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [authState, setAuthState] = useState({
    isLoggedIn: false,
    userData: null,
    loading: true,
  });

  useEffect(() => {
    const checkAuthStatus = () => {
      const token = localStorage.getItem("token");
      const savedUserData = localStorage.getItem("userData");

      if (!token || !savedUserData) {
        setAuthState({ isLoggedIn: false, userData: null, loading: false });
        return;
      }

      try {
        if (savedUserData === "undefined" || savedUserData === "null") {
          throw new Error("Invalid user data format");
        }
        const parsedUserData = JSON.parse(savedUserData);
        // console.log(savedUserData)
        const isValidUserData =
          parsedUserData && (parsedUserData.id || parsedUserData.email);

        if (isValidUserData) {
          setAuthState({
            isLoggedIn: true,
            userData: parsedUserData,
            loading: false,
          });
        } else {
          throw new Error("Invalid user data structure");
        }
      } catch (error) {
        console.error("❌ Auth validation error:", error);
        // Clear invalid data
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        setAuthState({ isLoggedIn: false, userData: null, loading: false });
      }
    };

    checkAuthStatus();
  }, []);

  const login = (userData, token) => {
    localStorage.setItem("token", token);
    localStorage.setItem("userData", JSON.stringify(userData));
    setAuthState({ isLoggedIn: true, userData, loading: false });
  };
  const logout = () => {
    localStorage.clear();
    setAuthState({
      isLoggedIn: false,
      userData: null,
      loading: false,
    });
  };

  const updateUserData = (updatedData) => {
    const newUserData = { ...authState.userData, ...updatedData };
    setAuthState((prev) => ({ ...prev, userData: newUserData }));
    localStorage.setItem("userData", JSON.stringify(newUserData));
  };

  const value = {
    ...authState,
    login,
    logout,
    updateUserData,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
